<template>
    <div class="flex items-end justify-between">
        <span class="text-sm text-zinc-500">{{ $t('game_stats.segments_accuracy') }}</span>
        <div class="flex flex-col items-end gap-1 ml-2">
            <span class="text-sm text-zinc-500 uppercase"> {{ hits }}/{{ dartsThrown }} </span>
            <span class="text-lg font-bold leading-none text-green-600">{{ accuracyLabel }}</span>
        </div>
    </div>
</template>

<script>
import { DART_TYPES } from '@/constants/dartTypes.js'

export default {
    name: 'SegmentsAccuracy',
    props: {
        // The player's segment list; each carries a cumulative `hits` count.
        segments: {
            type: Array,
            default: () => [],
        },
        // Darts thrown this leg before the in-progress turn.
        dartsSubmitted: {
            type: Number,
            default: 0,
        },
        // In-progress darts (active player only).
        enteredDarts: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        hits() {
            const serverHits = this.segments.reduce((total, s) => total + (s.hits || 0), 0)
            const liveHits = this.enteredDarts.filter((d) => d.dart_type !== DART_TYPES.MISS).length
            return serverHits + liveHits
        },
        dartsThrown() {
            return this.dartsSubmitted + this.enteredDarts.length
        },
        accuracyLabel() {
            if (!this.dartsThrown) return '—'
            return `${Math.round((this.hits / this.dartsThrown) * 100)}%`
        },
    },
}
</script>
